<template>
  <div>
    <!-- PC端顶部 start -->
    <div class="header" v-if="windowWidth > 769">
      <div class="navbox">
        <div class="home clearfix">
          <router-link :to="{ name: 'home' }" class="logo fl"></router-link>
          <div class="logon fr">
            <a :href="loginUrl" class="nav_a" v-show="isShowLogin" @click="login">登录</a>
            <a href="javascript:;" class="nav_a" v-show="isShowName">{{
              "欢迎您，" + userName
            }}</a>
            <a href="javascript:;" class="nav_a" v-show="isShowName" @click="loginOut">退出</a>
            <!-- <a href class="nav_a">忘记密码</a>| -->
            <a href="http://company.drcnet.com.cn/about.html?class=jj" target="_blank" class="nav_a">关于我们</a>
            <router-link :to="{ path: '/introduce' }" class="nav_a">产品介绍</router-link>
            <a href="http://misc.drcnet.com.cn/help/index.aspx" target="_blank" class="nav_a">使用帮助</a>
            <a href="http://misc.drcnet.com.cn/DRCNet.Users.Web/User/UserMain.aspx" target="_blank"
              class="nav_a">会员专区</a>
          </div>
        </div>
      </div>
      <div class="text animated fadeInUp home">
        <img src="@/assets/imgs/logo_bg.png" class="logo_img" />
        <search ref="search" :url="url" />
        <p style="
            text-align: center;
            color: #99d9ea;
            font-size: 20px;
            font-weight: 700;
          ">
          报告总量
          <span style="color: #fff200; font-weight: 700">{{ reportNum }}</span>篇，昨日新增
          <span style="color: #fff200; font-weight: 700">{{
            reportNewnum
          }}</span>篇
        </p>
      </div>
    </div>
    <!-- PC端顶部 end -->
    <!-- 移动端顶部 start -->
    <div class="header" v-if="windowWidth < 769">
      <div class="navbox">
        <div class="home clearfix">
          <router-link :to="{ name: 'home' }" class="logo fl"></router-link>
          <div class="aaa">
            <van-icon name="user-circle-o" color="#fff" class="button-main fr" @click="isShowUser = !isShowUser" />
          </div>
          <van-overlay :show="isShowUser" @click="isShowUser = false" />
          <div class="logon-m fr" v-show="isShowUser">
            <div class="triangle-down"></div>
            <a :href="loginUrl" class="nav_a" v-show="isShowLogin" @click="login">登录</a>
            <a href="javascript:;" class="nav_a" v-show="isShowName">{{
              "欢迎您，" + userName
            }}</a>
            <a href="javascript:;" class="nav_a" v-show="isShowName" @click="loginOut">退出</a>
            <!-- <a href class="nav_a">忘记密码</a>| -->
            <a href="http://company.drcnet.com.cn/about.html?class=jj" target="_blank" class="nav_a">关于我们</a>
            <!-- <router-link :to="{ path: '/introduce' }" class="nav_a"
              >产品介绍</router-link
            > -->
            <a href="http://misc.drcnet.com.cn/help/index.aspx" target="_blank" class="nav_a">使用帮助</a>
            <a href="http://misc.drcnet.com.cn/DRCNet.Users.Web/User/UserMain.aspx" target="_blank"
              class="nav_a">会员专区</a>
          </div>
        </div>
      </div>
      <div class="text animated fadeInUp home">
        <img src="@/assets/imgs/logo_bg.png" class="logo_img" />
        <search ref="search" :url="url" />
        <p style="
            text-align: center;
            color: #99d9ea;
            font-size: 20px;
            font-weight: 700;
          ">
          报告总量
          <span style="font-size: 20px; color: #fff200; font-weight: 700">{{
            reportNum
          }}</span>篇，昨日新增
          <span style="font-size: 20px; color: #fff200; font-weight: 700">{{
            reportNewnum
          }}</span>篇
        </p>
      </div>
    </div>
    <!-- 移动端顶部 end -->
    <!-- PC端菜单 start -->
    <div class="menu" v-if="indexMenu && windowWidth > 769">
      <div class="home clearfix">
        <ul class="fl ul1">
          <li class="menu_li">
            <router-link :to="{ name: 'home' }" class="navtxt">首页</router-link>
          </li>
          <li class="menu_li">
            <router-link :to="{ name: 'weekReport', query: { uid: '周评' } }" class="navtxt"
              :class="{ navtxtHover: this.$route.query.uid === '周评' }">周评</router-link>
          </li>
          <li class="menu_li">
            <router-link :to="{ name: 'weekReport', query: { uid: '月度报告' } }" class="navtxt"
              :class="{ navtxtHover: this.$route.query.uid === '月度报告' }">月度报告</router-link>
          </li>
          <li class="menu_li">
            <router-link :to="{ name: 'weekReport', query: { uid: '季度报告' } }" class="navtxt"
              :class="{ navtxtHover: this.$route.query.uid === '季度报告' }">季度报告</router-link>
          </li>
          <li class="menu_li">
            <router-link :to="{ name: 'yearReport', query: { uid: '年度报告' } }" class="navtxt"
              :class="{ navtxtHover: this.$route.query.uid === '年度报告' }">年度报告</router-link>
          </li>
          <li class="menu_li">
            <router-link :to="{ name: 'weekReport', query: { uid: '热点报告' } }" class="navtxt"
              :class="{ navtxtHover: this.$route.query.uid === '热点报告' }">热点报告</router-link>
          </li>
          <li class="menu_li">
            <a href="javascript:;" class="navtxt">专题报告</a>
            <ul class="nav_cd" style="left: 537px; text-align: center">
              <li v-for="item in topicMenu" :key="item.uid" v-if="item.apptext === '互联网金融'">
                <router-link :to="{
                  path: '/specialReport',
                  query: { uid: item.apptext, id: item.uid },
                }">{{ item.apptext }}</router-link>
              </li>
              <li>
                <a :href="indexLinkURL +
                  '/eDRCnet.common.web/DocDetail.aspx?chnid=6501&leafid=26276&docid=3684000&uid=900103&version=dReport&imgShowType=1'
                  " target="_blank">智慧城市</a>
              </li>
              <li>
                <a :href="indexLinkURL +
                  '/eDRCnet.common.web/DocDetail.aspx?chnid=6501&leafid=26277&docid=5783244&uid=900104&version=dReport&imgShowType=1'
                  " target="_blank">金融科技</a>
              </li>
              <li>
                <a :href="indexLinkURL +
                  '/eDRCnet.common.web/DocDetail.aspx?chnid=6501&leafid=26278&docid=5778059&uid=900105&version=dReport&imgShowType=1'
                  " target="_blank">大数据</a>
              </li>
              <li>
                <a :href="indexLinkURL +
                  '/eDRCnet.common.web/DocDetail.aspx?chnid=6501&leafid=27053&docid=6011076&uid=900107&version=dReport&imgShowType=1'
                  " target="_blank">数字经济指数</a>
              </li>
              <li>
                <a :href="indexLinkURL +
                  '/eDRCnet.common.web/DocDetail.aspx?chnid=06501&leafid=27054&docid=6013634&uid=900108&version=dReport&imgShowType=1'
                  " target="_blank">绿色金融指数</a>
              </li>
            </ul>
          </li>
          <li class="menu_li">
            <a href="javascript:;" class="navtxt">观大势系列</a>
            <ul class="nav_ds" style="left: 649px; text-align: center">

              <li>
                <router-link :to="{
                  path: '/allReports',
                  query: { idname: '重要会议专题', id: '900801' },
                }">重要会议专题</router-link>
              </li>
              <li>
                <router-link :to="{
                  path: '/allReports',
                  query: { idname: '重要政策专题', id: '900802' },
                }">重要政策专题</router-link>
              </li>

            </ul>
          </li>
          <li class="menu_li">
            <router-link :to="{ path: '/customReport' }" class="navtxt" style="color: #ffff00">定制报告</router-link>
          </li>
          <li class="menu_li">
            <a href="javascript:;" class="navtxt on">我的订阅</a>
            <ul class="nav_cd" style="width: 1200px; left: 0px">
              <li v-if="outloginMenu">
                <div class="menu_li_divnav">
                  <span>{{ menuMessage }}</span>
                </div>
              </li>
              <li v-for="items in mySubscriptions" :key="items.uid" v-if="loginMenu">
                <div class="menu_li_divnav">
                  <span>{{ items.apptext }}：</span>
                  <router-link :to="{
                    path: '/allReports',
                    query: { id: item.uid, idname: item.apptext },
                  }" class="divnav_a" v-for="item in items.children" :key="item.uid">{{ item.apptext }}</router-link>
                </div>
              </li>
            </ul>
          </li>
        </ul>
        <div class="fr ul1">
          <span class="navtxt" style="font-size: 16px; color: #fff">{{
            newTime
          }}</span>
        </div>
      </div>
    </div>
    <div class="menu" v-if="subpageMenu && windowWidth > 769">
      <div class="home clearfix">
        <div class="subnav1 fl">
          <i></i>
          <span>领域分类</span>
        </div>
        <ul class="fr ul1">
          <li class="menu_li">
            <router-link :to="{ path: '/weekReport', query: { uid: '全部报告' } }" class="navtxt"
              :class="{ navtxtHover: this.$route.query.uid === '全部报告' }"
              style="border-left: 1px solid #025f93">全部报告</router-link>
          </li>
          <li class="menu_li">
            <router-link :to="{ name: 'weekReport', query: { uid: '周评' } }" class="navtxt" :class="{
              navtxtHover:
                this.$route.query.uid === '周评' &&
                this.$route.name !== 'allReport',
            }">周评</router-link>
          </li>
          <li class="menu_li">
            <router-link :to="{ name: 'weekReport', query: { uid: '月度报告' } }" class="navtxt" :class="{
              navtxtHover:
                this.$route.query.uid === '月度报告' &&
                this.$route.name !== 'allReport',
            }">月度报告</router-link>
          </li>
          <li class="menu_li">
            <router-link :to="{ name: 'weekReport', query: { uid: '季度报告' } }" class="navtxt" :class="{
              navtxtHover:
                this.$route.query.uid === '季度报告' &&
                this.$route.name !== 'allReport',
            }">季度报告</router-link>
          </li>
          <li class="menu_li">
            <router-link :to="{ name: 'yearReport', query: { uid: '年度报告' } }" class="navtxt" :class="{
              navtxtHover:
                this.$route.query.uid === '年度报告' &&
                this.$route.name !== 'allReport',
            }">年度报告</router-link>
          </li>
          <li class="menu_li">
            <router-link :to="{ name: 'weekReport', query: { uid: '热点报告' } }" class="navtxt" :class="{
              navtxtHover:
                this.$route.query.uid === '热点报告' &&
                this.$route.name !== 'allReport',
            }">热点报告</router-link>
          </li>

          <li class="menu_li">
            <a href="javascript:;" class="navtxt">专题报告</a>
            <ul class="nav_cd" style="left: 570px; text-align: center">
              <li v-for="item in topicMenu" :key="item.uid" v-if="item.apptext === '互联网金融'">
                <router-link :to="{
                  path: '/specialReport',
                  query: { uid: item.apptext, id: item.uid },
                }">{{ item.apptext }}</router-link>
              </li>
              <li>
                <a :href="indexLinkURL +
                  '/eDRCnet.common.web/DocDetail.aspx?chnid=6501&leafid=26276&docid=3684000&uid=900103&version=dReport&imgShowType=1'
                  " target="_blank">智慧城市</a>
              </li>
              <li>
                <a :href="indexLinkURL +
                  '/eDRCnet.common.web/DocDetail.aspx?chnid=6501&leafid=26277&docid=5783244&uid=900104&version=dReport&imgShowType=1'
                  " target="_blank">金融科技</a>
              </li>
              <li>
                <a :href="indexLinkURL +
                  '/eDRCnet.common.web/DocDetail.aspx?chnid=6501&leafid=26278&docid=5778059&uid=900105&version=dReport&imgShowType=1'
                  " target="_blank">大数据</a>
              </li>
              <li>
                <a :href="indexLinkURL +
                  '/eDRCnet.common.web/DocDetail.aspx?chnid=6501&leafid=27053&docid=6011076&uid=900107&version=dReport&imgShowType=1'
                  " target="_blank">数字经济指数</a>
              </li>
              <li>
                <a :href="indexLinkURL +
                  '/eDRCnet.common.web/DocDetail.aspx?chnid=06501&leafid=27054&docid=6013634&uid=900108&version=dReport&imgShowType=1'
                  " target="_blank">绿色金融指数</a>
              </li>
            </ul>
          </li>
          <li class="menu_li">
            <a href="javascript:;" class="navtxt">观大势系列</a>
            <ul class="nav_ds" style="left: 682px; text-align: center">

              <li>
                <router-link :to="{
                  path: '/allReports',
                  query: { idname: '重要会议专题', id: '900801' },
                }">重要会议专题</router-link>
              </li>
              <li>
                <router-link :to="{
                  path: '/allReports',
                  query: { idname: '重要政策专题', id: '900802' },
                }">重要政策专题</router-link>
              </li>

            </ul>
          </li>
          <li class="menu_li">
            <router-link :to="{ name: 'home' }" class="navtxt" style="color: #ffff00">回到首页</router-link>
          </li>
        </ul>
      </div>
    </div>
    <!-- PC端菜单 end -->
    <!-- 移动端菜单 start -->
    <div class="menu" v-if="windowWidth < 769">
      <div class="home clearfix">
        <van-tabs v-if="topicMenu.length > 0" v-model="mTab" @click="mNavLink" swipeable>
          <van-tab name="home" title="首页"></van-tab>
          <van-tab name="weekReport1" title="周评"></van-tab>
          <van-tab name="weekReport2" title="月度报告"></van-tab>
          <van-tab name="weekReport3" title="季度报告"></van-tab>
          <van-tab name="yearReport4" title="年度报告"></van-tab>
          <van-tab name="weekReport5" title="热点报告"></van-tab>
          <!-- <van-tab name="customReport0" title="定制报告"></van-tab> -->
          <!-- <van-tab name="mSubscribe" title="我的订阅">
            <template #title>
              <van-dropdown-menu>
                <van-dropdown-item title="我的订阅">
                  <van-cell class="m-li-style">
                    <li v-if="outloginMenu">
                      <div class="menu_li_divnav">
                        <span>{{ menuMessage }}</span>
                      </div>
                    </li>
                    <li
                      v-for="items in mySubscriptions"
                      :key="items.uid"
                      v-if="loginMenu"
                    >
                      <div class="menu_li_divnav">
                        <span>{{ items.apptext }}：</span>
                        <router-link
                          :to="{
                            path: '/allReports',
                            query: { id: item.uid, idname: item.apptext },
                          }"
                          class="divnav_a"
                          v-for="item in items.children"
                          :key="item.uid"
                          >{{ item.apptext }}</router-link
                        >
                      </div>
                    </li>
                  </van-cell>
                </van-dropdown-item>
              </van-dropdown-menu>
            </template>
</van-tab> -->
          <van-tab name="mReport0" title="专题报告">
            <template #title>
              <div @click="navDropdownState = !navDropdownState">专题报告 <van-icon name="more-o" /></div>
            </template>
            <van-overlay :show="navDropdownState" @click="navDropdownState = false">
              <ul class="m-li-style">
                <li v-for="item in JSON.parse(mTopicMenus)" :key="item.uid" v-if="item.apptext === '互联网金融'">
                  <router-link :to="{
                    path: '/specialReport',
                    query: { uid: item.apptext, id: item.uid },
                  }">{{ item.apptext }}</router-link>
                </li>
                <li>
                  <a :href="indexLinkURL +
                    '/eDRCnet.common.web/DocDetail.aspx?chnid=6501&leafid=26276&docid=3684000&uid=900103&version=dReport&imgShowType=1'
                    " target="_blank">智慧城市</a>
                </li>
                <li>
                  <a :href="indexLinkURL +
                    '/eDRCnet.common.web/DocDetail.aspx?chnid=6501&leafid=26277&docid=5783244&uid=900104&version=dReport&imgShowType=1'
                    " target="_blank">金融科技</a>
                </li>
                <li>
                  <a :href="indexLinkURL +
                    '/eDRCnet.common.web/DocDetail.aspx?chnid=6501&leafid=26278&docid=5778059&uid=900105&version=dReport&imgShowType=1'
                    " target="_blank">大数据</a>
                </li>
                <li>
                  <a :href="indexLinkURL +
                    '/eDRCnet.common.web/DocDetail.aspx?chnid=6501&leafid=27053&docid=6011076&uid=900107&version=dReport&imgShowType=1'
                    " target="_blank">数字经济指数</a>
                </li>
                <li>
                  <a :href="indexLinkURL +
                    '/eDRCnet.common.web/DocDetail.aspx?chnid=06501&leafid=27054&docid=6013634&uid=900108&version=dReport&imgShowType=1'
                    " target="_blank">绿色金融指数</a>
                </li>
              </ul>
            </van-overlay>
          </van-tab>
          <van-tab name="mReport0" title="观大势系列">
            <template #title>
              <div @click="navDropdownStateGDS = !navDropdownStateGDS">观大势系列  <van-icon name="more-o" /></div>
            </template>
            <van-overlay :show="navDropdownStateGDS" @click="navDropdownStateGDS = false">
              <ul class="m-li-style">

                <li>
                  <router-link :to="{
                    path: '/allReports',
                    query: { idname: '重要会议专题', id: '900801' },
                  }">重要会议专题</router-link>
                </li>
                <li>
                  <router-link :to="{
                    path: '/allReports',
                    query: { idname: '重要政策专题', id: '900802' },
                  }">重要政策专题</router-link>
                </li>

              </ul>
            </van-overlay>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <!-- 移动端菜单 end -->
  </div>
</template>

<script>
import Search from "@/components/search";
import { api } from "@/pages/index/require/api";
import {
  getName,
  setName,
  removeName,
  getToken,
  setToken,
  removeToken,
} from "@/pages/index/require/auth";
import axios from "axios";
export default {
  name: "top",
  components: {
    Search,
  },
  data() {
    return {
      url: [
        "http://s1.drcnet.com.cn/search/SearchAC.aspx?chnId=6500&fields=",
        "",
      ],
      newTime: "",
      topicMenu: [],
      indexMenu: false,
      subpageMenu: true,
      loginUrl: "",
      isShowLogin: true,
      isShowName: false,
      userName: "",
      mySubscriptions: [],
      outloginMenu: false,
      loginMenu: false,
      menuMessage: "",
      reportNum: 0,
      reportNewnum: 0,
      indexLinkURL: window.indexLinkURL,
      indexBaseURL: window.indexBaseURL,
      isShowUser: false,
      mTab: "",
      mTopicMenus: "",
      navDropdownState: false,
      navDropdownStateGDS:false
    };
  },
  created() {
    this.mTab = "";
    this.logenter();
    // this.loadmySubscriptions();

    this.loadtime();
    if (
      this.$route.name === "home" ||
      this.$route.name === "introduce" ||
      this.$route.name === "customReport"
    ) {
      (this.indexMenu = true), (this.subpageMenu = false);
      this.loadsubmenu();
    } else if (this.$route.name === "specialReport" && this.windowWidth > 769) {
      (this.indexMenu = false), (this.subpageMenu = false);
    } else {
      (this.indexMenu = false), (this.subpageMenu = true);
      this.loadsubmenu();
    }
    this.isHttp();
  },
  mounted() {
    this.loadtime();
    if (getToken() !== null && getName() !== null) {
      this.isShowLogin = false;
      this.isShowName = true;
      this.userName = getName();
    } else {
      this.isShowLogin = true;
      this.isShowName = false;
      this.outloginMenu = true;
      this.loginMenu = false;
      this.menuMessage = "请您登录!";
    }
    // 移动端导航跳转
    if (
      sessionStorage.getItem("navName") &&
      sessionStorage.getItem("navName") != "" &&
      sessionStorage.getItem("navName") != null &&
      sessionStorage.getItem("navName") != undefined
    ) {
      this.mTab = sessionStorage.getItem("navName");
    } else {
      this.mTab = "首页";
    }
  },
  methods: {
    // 获取栏目
    async loadsubmenu() {
      const { code, data } = await api.get(
        "/indexController/getChildSpecialChanels"
      );
      if (code === 0) {
        this.topicMenu = data.children;
        sessionStorage.setItem("topicMenus", JSON.stringify(this.topicMenu));
        this.mTopicMenus = sessionStorage.getItem("topicMenus");
      }
    },
    // 订阅
    loadmySubscriptions() {
      let token = getToken();
      token === null ? (token = "") : (token = getToken());
      return axios({
        method: "get",
        url:
          this.indexBaseURL + "/reportapi/indexController/getMySubscriptions",
        headers: {
          Authorization: token,
        },
      }).then((res) => {
        if (res.data.code === 300) {
          this.outloginMenu = true;
          this.loginMenu = false;
          this.menuMessage = "请您登录";
        } else if (res.data.code === 100) {
          this.outloginMenu = true;
          this.loginMenu = false;
          this.menuMessage = res.data.message;
        } else {
          this.outloginMenu = false;
          this.loginMenu = true;
          this.mySubscriptions = res.data.data.children;
        }
      });
    },
    // 获取时间
    async loadtime() {
      const { code, data } = await api.get("/indexController/getIndexDate", {
        time: new Date().getTime(),
      });
      if (code === 0) {
        this.newTime = data.date;
        this.reportNum = data.totalCount;
        this.reportNewnum = data.yeTotalCount;
      }
    },
    // 判断网址是http还是https
    isHttp() {
      if (window.location.protocol.indexOf("https") !== -1) {
        return "https://user.drcnet.com.cn/userapi/loginController/initLoginP";
      } else {
        return "http://user.drcnet.com.cn/userapi/loginController/initLoginP";
      }
    },
    // 点击登录
    login() {
      let url = `http://user.drcnet.com.cn/#/login`;
      this.loginUrl =
        url +
        "?gourl=" +
        window.location.href.replace("?", "~~").replace("&", "^");
    },
    logenter() {
      let baseUrl = this.isHttp();
      let loginUrl = `${baseUrl}`;
      this.$jsonp(loginUrl, { flag: "initp", callbackName: "showData" })
        .then((res) => {
          if (res.Logined === 1) {
            setName(res.UserName);
            setToken(res.UserToken);
            this.isShowLogin = false;
            this.isShowName = true;
            this.userName = getName();
            this.loadmySubscriptions();
          } else {
            removeName();
            removeToken();
            this.isShowLogin = true;
            this.isShowName = false;
          }
          // resolve();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 点击退出
    loginOut() {
      let url = this.indexLinkURL + "/eDRCnet.common.web/login.ashx";
      let loginUrl = `${url}`;
      this.$jsonp(loginUrl, { flag: "logoutp", callbackName: "showData" })
        .then((res) => {
          if (res.Logined == 0) {
            removeName();
            removeToken();
            this.isShowLogin = true;
            this.isShowName = false;
            this.$router.go(0);
          }
          // 判断本页面是否为首页
          // resolve();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 展示user
    mNavLink(name, title) {
      if (name) {
        sessionStorage.setItem("navName", name);
        this.mTab = sessionStorage.getItem("navName");
        let useName = name.slice(0, -1);
        if (
          title != "首页" &&
          title != "定制报告" &&
          title != "专题报告" &&
          title != "我的订阅" &&
          title != "观大势系列"
        ) {
          this.$router.push({ name: useName, query: { uid: title } });
        } else if (title == "定制报告") {
          this.$router.push({ path: useName });
        } else if (title == "专题报告") {
          return;
        } else if (title == "我的订阅") {
          return;
        }else if (title == "观大势系列") {
          return;
        } else {
          this.$router.push({ name: "home" });
        }
      }
    },
  },
};
</script>

<style lang='less' scoped>
.header {
  background: url(../assets/imgs/header_bj.jpg) no-repeat;
  height: 322px;
  width: 100%;
  background-position: center;

  .navbox {
    background: rgba(11, 96, 159, 0.5);
    width: 100%;
    height: 50px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0px 5px 12px #103280;

    .logo {
      background: url(../assets/imgs/logo.png) no-repeat;
      height: 31px;
      width: 92px;
      margin-top: 10px;
    }

    .logon {
      color: #4477aa;

      .nav_a {
        color: #fff;
        padding: 0 10px;
        line-height: 48px;
        border-right: 1px solid #4477aa;
      }

      .nav_a:hover {
        color: #0cf;
      }
    }
  }

  .text {
    position: relative;
    top: 65px;
    width: 675px;
    height: 145px;
    -webkit-transition-delay: 150ms;
    -moz-transition-delay: 150ms;
    transition-delay: 150ms;

    .logo_img {
      margin: 0 auto;
    }
  }
}

.fadeInUp {
  -webkit-animation-name: fadeInUp;
  animation-name: fadeInUp;
}

.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    /*-webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);*/
    -webkit-transform: translate3d(0, 50px, 0);
    transform: translate3d(0, 50px, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

.menu {
  height: 45px;
  line-height: 43px;
  background: #0770b9;

  .ul1 {
    position: relative;

    .menu_li {
      float: left;
      border-right: 1px solid #025f93;

      .navtxt {
        color: #fff;
        // padding: 0 20px;
        padding: 0 17px;
        font-size: 17px;
        height: 45px;
        display: block;
      }

      .navtxt:hover {
        background: #1399ee;
      }
    }

    .menu_li:last-child:hover .nav_cd {
      display: block;
    }

    .menu_li:last-child:hover .nav_ds {
      display: block;
    }


    .menu_li:nth-child(7):hover .nav_cd {
      display: block;
    }

    .menu_li:nth-child(8):hover .nav_ds {
      display: block;
    }
  }

  .subnav1 {
    height: 45px;
    background: #015d9e;
    width: 270px;

    i {
      background: url(../assets/imgs/cdimg.png) no-repeat;
      width: 17px;
      height: 14px;
      display: block;
      float: left;
      margin-left: 20px;
      margin-top: 16px;
      margin-right: 15px;
    }

    span {
      color: #fff;
      font-size: 17px;
    }
  }
}

/*我的订阅菜单*/
.nav_cd {
  display: none;
  padding: 15px 25px;
  background: rgba(0, 52, 122, 0.9);
  border-bottom: #1d9bec 4px solid;
  position: absolute;
  z-index: 1;
  font-size: 15px;

  li {
    border-bottom: 1px dashed #5473a1;

    a {
      color: #edf5ff;
      display: inline-block;
    }

    a:hover {
      color: #ffff00 !important;
    }
  }

  li:last-child {
    border-bottom: none;
  }
}

.nav_ds {
  display: none;
  padding: 15px 25px;
  background: rgba(0, 52, 122, 0.9);
  border-bottom: #1d9bec 4px solid;
  position: absolute;
  z-index: 1;
  font-size: 15px;

  li {
    border-bottom: 1px dashed #5473a1;

    a {
      color: #edf5ff;
      display: inline-block;
    }

    a:hover {
      color: #ffff00 !important;
    }
  }

  li:last-child {
    border-bottom: none;
  }
}

// .menu_li{ position:relative;}
.menu_li_divnav span {
  font-weight: bold;
  color: #26e1ff;
}

.menu_li_divnav .divnav_a {
  padding-right: 15px;
}

.navtxtHover {
  background: #1399ee;
}

/deep/.el-input__inner {
  border-radius: 0px !important;
  height: 38px !important;
}

/deep/.searchbox {
  width: 675px;
  height: 60px;
  float: right;
  margin-top: 30px;
  background: url(../assets/imgs/s_bj.png) no-repeat;
  margin: 25px auto;
  margin-bottom: 15px;
  padding: 0;

  /deep/.search {
    width: 500px;
    float: left;
    margin-left: 15px;
    margin-top: 10px;

    .el-input__inner {
      height: 38px !important;
    }
  }

  .searchbtna {
    width: 65px;
    background-color: #02b1b7;
    border-right: 0;
  }

  .searchbtnb {
    width: 80px;
    background-color: #0075d0;
  }

  .searchbtna,
  .searchbtnb {
    margin-top: 10px;
    text-align: center;
    line-height: 38px;
    float: left;
    cursor: pointer;
    color: #fff;
    font-size: 14px;
  }
}

::v-deep .searchinput {
  // width: 410px;
  float: left;
}

/deep/.el-select {
  float: left;
  width: 90px !important;
  height: 100% !important;
}

.aaa:hover .logon-m {
  display: block;
}

@media screen and (max-width: 769px) {
  .header {
    width: 100%;

    .home {
      width: 100% !important;

      .button-main {
        font-size: 32px;
        color: white;
        margin: 8px 16px;
      }

      .logon-m {
        // display: none;
        -webkit-animation: scale-in-tr 0.15s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
        animation: scale-in-tr 0.15s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
        position: absolute;
        right: 8px;
        background: white;
        width: 100px;
        z-index: 9999;
        margin-top: 60px;
        border-radius: 5px;
        padding: 0 8px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

        .triangle-down {
          position: absolute;
          top: -20px;
          left: 65px;
          width: 0;
          height: 0;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-top: 10px solid transparent;
          border-bottom: 10px solid #fff;
        }

        a {
          display: block;
          text-align: center;
          color: #333;

          &:not(:first-child) {
            padding: 8px 0 8px 0;
          }

          &:not(:last-child) {
            border-bottom: 1px dashed #ddd;
          }
        }
      }
    }

    .logo_img {
      width: 80%;
    }

    .searchbox {
      width: 85%;
      float: none !important;
    }

    ::v-deep .el-select {
      width: 20% !important;
    }

    .searchinput {
      width: 60% !important;
    }

    .searchbox .searchbtna {
      width: 10%;
    }
  }

  .m-li-style {
    background: #fff;
    padding: 0 16px;
    margin-top: 368px;
    box-shadow: 0 10px 10px #333;

    li {
      text-align: center;

      a {
        color: #333;
      }

      padding: 0 8px;
      list-style-type: none;

      &:not(:last-child) {
        border-bottom: 1px dashed #ddd;
      }
    }
  }

  .van-overlay {
    background-color: rgba(0, 0, 0, 0);
    /* 调整为你想要的颜色 */
  }

  .van-tabs {
    z-index: 1;
  }
}

@-webkit-keyframes scale-in-tr {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: 80% 0%;
    transform-origin: 80% 0%;
    opacity: 1;
  }

  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transform-origin: 80% 0%;
    transform-origin: 80% 0%;
    opacity: 1;
  }
}

@keyframes scale-in-tr {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: 80% 0%;
    transform-origin: 80% 0%;
    opacity: 1;
  }

  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transform-origin: 80% 0%;
    transform-origin: 80% 0%;
    opacity: 1;
  }
}

::v-deep .van-dropdown-menu__bar {
  box-shadow: none !important;
}
</style>